import React from 'react'
import { useTranslation } from "react-i18next";
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Box
} from '@mui/material';

const CrmNumberRange = (props) => {
    const { name, label, value = {}, onChange, disabled, sx, required, maxNumber } = props
    const [t] = useTranslation('crm');

    const operators = [
        { value: 'equals', label: 'Equals' },
        { value: 'ne', label: 'Not Equal To' },
        { value: 'gt', label: 'Greater Than' },
        { value: 'lt', label: 'Less Than' },
        { value: 'gte', label: 'Greater Than or Equal To' },
        { value: 'lte', label: 'Less Than or Equal To' }
    ];

    const handleOperatorChange = (event) => {
        const newOperator = event.target.value;
        onChange({
            target: {
                name,
                value: {
                    ...value,
                    operator: newOperator,
                    // Reset comparison value when operator changes
                    comparisonValue: value.comparisonValue || ''
                }
            }
        });
    };

    const handleValueChange = (event) => {
        const newValue = event.target.value;
        
        // Validate against maxNumber if it's set
        if (maxNumber && newValue !== '') {
            const inputValue = parseFloat(newValue);
            const maxValue = parseFloat(maxNumber);
            
            if (!isNaN(inputValue) && !isNaN(maxValue) && inputValue > maxValue) {
                // Don't allow the change if it exceeds maxNumber
                return;
            }
        }
        
        onChange({
            target: {
                name,
                value: {
                    ...value,
                    operator: value.operator || 'equals',
                    comparisonValue: newValue
                }
            }
        });
    };

    return (
        <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
            <FormControl size="small" disabled={disabled} sx={{ minWidth: 120, flex: 1 }}>
                <InputLabel>{`${label} - ${t('Operator')}`}</InputLabel>
                <Select
                    value={value.operator || 'equals'}
                    onChange={handleOperatorChange}
                    label={`${label} - ${t('Operator')}`}
                >
                    {operators.map(op => (
                        <MenuItem 
                            key={op.value} 
                            value={op.value}
                            sx={{ 
                                direction: 'ltr', 
                                textAlign: 'right',
                                minHeight: '36px',
                                height: '36px'
                            }}
                        >
                            {t(op.label)}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            
            <TextField
                size="small"
                type="number"
                label={`${label} - ${t('Value')}`}
                value={value.comparisonValue || ''}
                onChange={handleValueChange}
                disabled={disabled}
                required={required}
                inputProps={maxNumber ? { max: maxNumber } : {}}
                sx={{ flex: 1 }}
            />
        </Box>
    )
}

export default CrmNumberRange